import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";

import { useMainStore } from "@/contexts/Store";

import { useScrollBoxWidth } from "../../../hooks/useScrollBoxWidth";
import plusIcon from "../../../images/table-image/icon/plus.svg";

type Props = {
  className?: string;
  dataTestIdPrefix?: string;
  offset?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (...args: any[]) => any;
  recordTypeName?: string;
};

const AddNewRow = ({
  onClick,
  dataTestIdPrefix,
  offset,
  recordTypeName,
  className,
}: Props) => {
  const mainStore = useMainStore();
  const [ref, scrollWidth] = useScrollBoxWidth();

  const { hasModuleWriteAccess } = mainStore.userPermissions;

  return (
    <div
      className={classNames("add-new-procedures", className, {
        "add-new-procedures--disabled": !hasModuleWriteAccess,
        "pointer-events-none": !hasModuleWriteAccess,
      })}
      // @ts-expect-error TS(2322) FIXME: Type '(element: HTMLElement) => void' is not assig... Remove this comment to see the full error message
      ref={ref}
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      style={{ width: `${scrollWidth - offset}px` }}
    >
      <div
        className="plus-sign"
        onClick={onClick}
        data-testid={`${dataTestIdPrefix}-plus-sign`}
        data-tooltip-id="tooltip"
        data-tooltip-content={`Add ${recordTypeName}`}
        data-tooltip-place="left"
      >
        <img src={plusIcon} alt="plus-icon" />
      </div>
      <button onClick={onClick} data-testid={`${dataTestIdPrefix}-button`}>
        Add New {recordTypeName} +
      </button>
    </div>
  );
};

AddNewRow.defaultProps = {
  offset: 151,
};

export default observer(AddNewRow);
